// src/app/shared/ui/layout/Layout.tsx
import { Outlet, useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { ConnectionStatusBanner } from "@/app/shared/ui/ConnectionStatusBanner";
import { useViewportInsets } from "@/app/hooks/useViewportInsets";
import { WelcomeModal } from "@/app/shared/ui/WelcomeModal";
import { FloatingBackground } from "@/app/core/ui/redisain/FloatingBackground";
import { useTheme } from "@/app/core/ui/theme/ThemeProvider";



export function Layout() {
  const location = useLocation();
  const isTextGeneration = location.pathname.startsWith("/text-generation");
  const isTopUp = location.pathname.startsWith("/top-up");
  const isCheckout = location.pathname === "/checkout";
  const isFullscreenPage =
    isTextGeneration ||
    isCheckout ||
    isTopUp ||
    location.pathname.startsWith("/profile/payment");

  const { systemInsets } = useViewportInsets();

  const isProfilePage = location.pathname === "/profile";
const isMainPage = location.pathname === "/";
  const bottomNavReservedSpace = 104;

  // Динамический верхний отступ (в браузере 0, в Telegram – реальный safe‑area)
  const paddingTop = `${systemInsets.top + 30}px`;
  const { resolvedTheme } = useTheme();
  const bottomContentPadding = isFullscreenPage
  ? "0"
  : isMainPage
    ? "0"
    : isProfilePage
      ? "0"
      : `calc(${bottomNavReservedSpace}px + ${systemInsets.bottom}px)`;
  return (
    <div
    
      style={{
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        color: "var(--foreground)",
        transition: "color 0.2s ease",
        position: "relative",
        paddingTop,
      }}
    >
      <FloatingBackground key={resolvedTheme} />
      <ConnectionStatusBanner topInset={systemInsets.top + 15}/>
      <main
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: isFullscreenPage ? "hidden" : "auto",
          paddingBottom: bottomContentPadding,
          position: "relative",
          zIndex: 10,
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            borderRadius: isFullscreenPage ? "0" : "24px 24px 0 0",
          }}
        >
          <Outlet />
        </div>
      </main>
      {!isFullscreenPage && <BottomNav />}
      <WelcomeModal enabled={!isFullscreenPage} />
    </div>
  );
};